import { PATHS } from '@/common/const'
import { classNames, createNoteLinkWithID } from '@/common/utils'
import Link from 'next/link'
import { useRouter } from 'next/router'

export const navItems = [
  { id: 'overview', name: 'Overview', href: '' },
  { id: 'note', name: 'Note', href: 'note' },
  { id: 'recipients', name: 'Recipients', href: 'recipients' },
  { id: 'settings', name: 'Note Settings', href: 'settings' },
  // { id: 'activate', name: 'Activate', href: 'activate' },
]

export function SubNav(props: React.PropsWithChildren) {
  const router = useRouter()
  const path = router?.route
  const note_id = router?.query?.id as string

  return (
    <div className="bg-white dark:text-gray-300 dark:bg-gray-900 border-b border-gray-300 dark:border-gray-600">
      <div className="mx-auto max-w-4xl px-4 sm:px-2 lg:px-6">
        <div
          role="list"
          className="flex flex-row flex-wrap justify-start divided-x"
        >
          <div className="py-2 px-4 first:pl-0">
            <Link
              className={classNames(
                'hover:text-blue-500 flex items-start hover:border-b hover:border-dashed'
              )}
              href={PATHS.NOTE_INDEX}
            >
              All Notes
            </Link>
          </div>
          {navItems.map((item, i) => {
            const isCurrent =
              (item.href.length == 0 && path.endsWith('[id]')) ||
              (item.href.length && path?.split?.('/')?.includes?.(item.href))

            return (
              <div
                className="py-2 px-4 first:pl-0"
                aria-current={isCurrent ? 'location' : undefined}
                key={i}
              >
                <Link
                  className={classNames(
                    'hover:text-blue-500 flex items-start hover:border-b hover:border-dashed',
                    isCurrent ? 'text-blue-600 border-b border-blue-600' : ''
                  )}
                  href={createNoteLinkWithID(note_id, item.href)}
                >
                  {item.name}
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
